import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function Profile() {
    const [student, setStudent] = useState({
        studentId: "STD_123",
        name: "Jhon",
        userName: "jhon",
        contact: "03114287204",
        password: "password",
        email: "jhon@gmail.com",
        address: "this is my address",
        birthDate: Date.now(),
    });


    const { t, i18n } = useTranslation();
    const [language, setLanguage] = useState("en");

    const handleLanguageChange = (newLanguage) => {
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };

    useEffect(() => {
        const data = JSON.parse(localStorage.getItem('ViewStudent'));
        setStudent(data);
    }, [])
    return (
        <>
            {/* <Form title={`${student?.name} Profile`} data={student} /> */}
            <div className="flex flex-row justify-end">
                <div class="flex flex-row items-center right-1 ">
                    <button class="p-2 flex flex-row items-center border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:bg-gray-200 focus:outline-none"
                        onClick={() => handleLanguageChange("en")}
                    >
                        <span className="text-md">{language !== "en" ? "En" : "English"}</span>
                        {language !== "en" && <span class="ml-1"> <img src="/images/english-48.png" className="w-5 h-5" /></span>}
                    </button>

                    <button class="p-2 flex flex-row items-center border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:bg-gray-200 focus:outline-none"
                        onClick={() => handleLanguageChange("tr")}
                    >
                        <span className="text-md">{language !== "tr" ? "Tr" : "Turkish"}</span>
                        {language !== "tr" && <span class="ml-1"> <img src="/images/turkey-48.png" className="w-5 h-5" /></span>}

                    </button>
                </div>
            </div>
            <div className="flex flex-row items-center space-x-5">
                <img
                    src={`https://api.dicebear.com/6.x/identicon/svg?seed=${student?.userName}`}
                    alt="avatar"
                    className="w-20 h-20 rounded-full border-[2px] border-gray-500 mt-2"
                />
                <div className="space-y-2">
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium text-xl md:text-4xl">{t('name')}</span> <h1 className="text-xl md:text-4xl font-normal">{student?.name}</h1>
                    </div>
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium text-md md:text-xl">{t('studentID')}:</span> <h1 className="text-md md:text-xl font-medium">{student?.studentId}</h1>
                    </div>
                </div>
            </div>
            <hr class="w-100 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-5 dark:bg-gray-700" />
            <div>
                <div className="space-y-5">
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium md:text-2xl">{t('userName')}:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.userName}</h1>
                    </div>
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium md:text-2xl">{t("email")}:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.email}</h1>
                    </div>
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium md:text-2xl">{t("contact")}:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.contact}</h1>
                    </div>
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium md:text-2xl">{t('birthDate')}:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.birthDate}</h1>
                    </div>
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium md:text-2xl">{t('address')}:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{student?.address}</h1>
                    </div>

                </div>
                <div class="inline-flex items-center justify-center w-full">
                    <hr class="w-full h-1 my-8 border-0 rounded bg-gray-700" />
                    <div class="absolute px-4  bg-slate-100 font-medium text-lg md:text-xl uppercase ">
                        {t('marks')}
                    </div>
                </div>
                <div className="space-y-2">
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium md:text-2xl">{t('obtainedMarks')}:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{80}</h1>
                    </div>
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium md:text-2xl">{t('totalMarks')}:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{120}</h1>
                    </div>
                    <div className="flex  items-center space-x-3">
                        <span className="font-medium md:text-2xl">{t('percentage')}:</span> <h1 className="text-md md:text-2xl md:font-normal text-gray-800">{66.66}%</h1>
                    </div>
                </div>
            </div>
        </>
    )

}